import { Link, useResolvedPath, useMatch } from 'react-router-dom';
import { useState } from 'react';

interface DashboardNavLinkProps {
  icon?: React.ReactNode;
  text?: string;
  to: string;
  children?: React.ReactNode;
  className?: string;
  collapsed?: boolean;
}

export default function DashboardNavLink({
  icon,
  text,
  to,
  children,
  className,
  collapsed = false,
}: DashboardNavLinkProps) {
  const resolved = useResolvedPath(to);
  const match = useMatch({ path: resolved.pathname, end: false });
  const [showTooltip, setShowTooltip] = useState(false);

  if (children) {
    return (
      <Link className={`${className} ${match ? 'active' : ''}`} to={to}>
        {children}
      </Link>
    );
  }

  return (
    <div className="relative w-full mb-3">
      <Link 
        className={`flex items-center group transition-all duration-200 px-3 py-2 mx-2 rounded-lg ${
          match 
            ? 'bg-primary bg-opacity-20 border-l-2 border-primary' 
            : 'hover:bg-gray-700 hover:bg-opacity-50'
        } ${collapsed ? 'justify-center' : 'justify-start'}`}
        to={to}
        onMouseEnter={() => collapsed && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <div
          className={`flex items-center justify-center transition-all duration-200 ${
            match ? 'text-primary' : 'text-gray-300 group-hover:text-primary'
          }`}
        >
          {icon ? (
            <div className="text-lg">
              {icon}
            </div>
          ) : (
            <div className="w-5 h-5 flex items-center justify-center text-xs font-bold">
              {text?.substring(0, 1).toUpperCase()}
            </div>
          )}
        </div>
        {!collapsed && text && (
          <span className={`ml-3 text-sm font-medium transition-all duration-200 ${
            match ? 'text-white' : 'text-gray-300 group-hover:text-white'
          }`}>
            {text}
          </span>
        )}
      </Link>
      
      {collapsed && showTooltip && text && (
        <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap z-50">
          {text}
        </div>
      )}
    </div>
  );
}
